module.exports = __webpack_public_path__ + "static/media/completed_inactive.91972ed1.svg";